export default __webpack_public_path__ + "static/media/elite_badge.04ef44c9.svg";